module.exports = require("node:timers/promises");